import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthProvider";

export const useAdminRole = () => {
  const { session } = useAuth();
  const userId = session?.user?.id;

  const { data: isAdmin, isLoading, error } = useQuery({
    queryKey: ["user_role", userId],
    queryFn: async () => {
      if (!userId) return false;

      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId)
        .eq("role", "admin")
        .maybeSingle();

      if (error) {
        if (import.meta.env.DEV) {
          console.error("Failed to verify admin role", error);
        }
        return false;
      }

      return !!data;
    },
    enabled: !!userId && !!session?.access_token,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000,
  });

  return {
    isAdmin: isAdmin ?? false,
    isLoading,
    error,
    userId,
  };
};
